import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { drawersConfiguration } from '@/features/drawer/constants/drawersConfiguration';
import { Drawers } from '@/features/drawer/enums/Drawers';
import RouteService from '@/services/RouteService/RouteService';

type useRouterDrawersProps = {
  includeHighlight?: boolean;
};

export const useRouterDrawers = (props?: useRouterDrawersProps) => {
  const { includeHighlight } = props || {};
  const location = useLocation();

  const activeDrawers = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);

    const [newActiveDrawers, newHighlightedDrawers] = Object.values(Drawers).reduce(
      ([activeAcc, hightlightAcc], drawerKey) => {
        let newActiveAcc = activeAcc;
        let newHighlightAcc = hightlightAcc;
        const isInRoute = searchParams.get(drawerKey) === 'true';

        if (isInRoute) {
          const checker = drawersConfiguration?.[drawerKey as Drawers]?.router?.allowedRoutes || [];
          const isAllowedDrawer = checker ? RouteService.checkRouteMatch(checker) : true;

          if (isAllowedDrawer) {
            newActiveAcc = [...activeAcc, drawerKey];
          }
        }
        const highlightDrawer = searchParams.get(`${drawerKey}-highlight`);
        if (includeHighlight && highlightDrawer) {
          newHighlightAcc = [...hightlightAcc, highlightDrawer as Drawers];
        }
        return [newActiveAcc, newHighlightAcc];
      },
      [[] as Drawers[], [] as Drawers[]],
    );

    return includeHighlight ? [...newHighlightedDrawers, ...newActiveDrawers] : newActiveDrawers;
  }, [location.search]);

  return activeDrawers;
};
